import { isDev } from "../config/env";

type LogLevel = "info" | "warn" | "error" | "debug";

const log = (level: LogLevel, ...args: any[]) => {
  if (isDev) {
    switch (level) {
      case "info":
        console.info("[INFO]", ...args);
        break;
      case "warn":
        console.warn("[WARN]", ...args);
        break;
      case "error":
        console.error("[ERROR]", ...args);
        break;
      case "debug":
      default:
        console.debug("[DEBUG]", ...args);
    }
  }
};

export const logger = {
  error: (...args: any[]) => log("error", ...args),
  warn: (...args: any[]) => log("warn", ...args),
  info: (...args: any[]) => log("info", ...args),
  debug: (...args: any[]) => log("debug", ...args),
  log,
};
